import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ModalController} from '@ionic/angular';
import {Ordine} from '../_models/Ordine';
import {OrdineEsolver} from '../_models/OrdineEsolver';
import {FaseInfo} from '../_models/ContenitoreInfo';
import {ContenitoreInfoComponent} from '../_components/contenitori/contenitore-info/contenitore-info.component';

// Azioni offerte dalla schermata che può aprire una fase (interfaccia manuale).
export interface ContenitoreInfoAzioni {
  apri(ordine: Ordine): void;
  lancia(ordine: OrdineEsolver): Promise<void>;
  // Feature 166: altre fasi del percorso, con la ricerca della scansione del codice ordine.
  cerca?(rifOrdine: string): void;
}

// Codice ordine a 17 cifre della fase (idDocumento 9 + idRiga 4 + idRigaLavorazione 4), come la scansione.
export const rifOrdineFase = (fase: FaseInfo): string =>
  `${fase.idDocumento}`.padStart(9, '0') + `${fase.idRiga}`.padStart(4, '0') +
  `${fase.idRigaLavorazione}`.padStart(4, '0');

interface Registrazione {
  azioni: ContenitoreInfoAzioni;
  percorso: string;
}

/**
 * Feature 162 «Info contenitore»: apre il modale da header, etichetta e lista contenitori.
 * Senza azioni registrate (o fuori dalla pagina che le ha registrate) il modale è in sola consultazione.
 */
@Injectable({providedIn: 'root'})
export class ContenitoreInfoModalService {
  private registrazione: Registrazione | null = null;

  constructor(private modalCtrl: ModalController, private router: Router) { }

  registraAzioni(azioni: ContenitoreInfoAzioni) {
    this.registrazione = {azioni, percorso: this.percorsoCorrente()};
  }

  rimuoviAzioni(azioni: ContenitoreInfoAzioni) {
    if (this.registrazione?.azioni === azioni) {
      this.registrazione = null;
    }
  }

  // Le pagine Ionic restano vive nello stack: le azioni valgono solo sulla pagina che le ha registrate.
  get azioniAttive(): ContenitoreInfoAzioni | null {
    const reg = this.registrazione;
    return reg && reg.percorso === this.percorsoCorrente() ? reg.azioni : null;
  }

  async apri(codBox = '') {
    const azioni = this.azioniAttive;
    const modal = await this.modalCtrl.create({
      component: ContenitoreInfoComponent,
      componentProps: {codBox, azioni},
      cssClass: 'custom-modal'
    });
    await modal.present();
    const {data, role} = await modal.onWillDismiss<FaseInfo>();
    if (!data || !azioni) {
      return;
    }
    if (role === 'cerca') {
      azioni.cerca?.(rifOrdineFase(data));
      return;
    }
    if (role !== 'confirm') {
      return;
    }
    if (data.ordine) {
      azioni.apri(data.ordine);
    } else if (data.ordineEsolver) {
      await azioni.lancia(data.ordineEsolver);
    }
  }

  private percorsoCorrente(): string {
    return this.router.url.split('?')[0];
  }
}
